import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { TrainInformation } from "../models/train-information.model";

@Injectable({
  providedIn: "root"
})
export class TrainOrderService {
  requestHeader: HttpHeaders = new HttpHeaders({ 
    "api-version": "1.0", 
    "app-version": "1.0" 
  });

  constructor(private httpClient: HttpClient) { }

  getTrainInformations(operationalDate: string): Observable<TrainInformation[]> {
    const url = `${environment.trainOrderBaseUrl}${environment.getTrainInformationsApiSuffix}?operationalDate=${operationalDate}`;
    return this.httpClient.get<TrainInformation[]>(url);
    // Temporarily removed custom headers - uncomment if needed
    // return this.httpClient.get<TrainInformation[]>(url, { 
    //   headers: this.requestHeader 
    // });
  }
}

